import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import EditRoleInformation from "../../components/common/editRoleInformation";
import EditRoleMenu from "../../components/common/editRoleMenu";
import { EditRole } from "../../services/admin/roleServices";
import { getUser } from "../../pages/userSlice";
import { useSelector } from "react-redux";
import { CODES } from "../../consts/codes";
import { GetMenuLevel1 } from "../../services/admin/adminServices";

const ModalEditRoles = (props) => {
  const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;

    return (
      <DialogTitle
        sx={{ m: 0, paddingTop: "2rem", paddingLeft: "0rem" }}
        {...other}
      >
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.primary[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  };

  BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
  };

  const userInfo = useSelector(getUser);
  const userData = {
    nameUser: `${userInfo.firstName} ${userInfo.lastName}`,
  };

  const [activeProducts, setActiveProducts] = useState([]);

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    async function fetchDataActiveProduct(data) {
      try {
        if (Object.keys(userInfo).length > 0) {
          const activeProductsService = await GetMenuLevel1();

          if (
            activeProductsService.status === CODES.COD_RESPONSE_HTTP_OK &&
            activeProductsService.data.responseCode ===
              CODES.COD_RESPONSE_SUCCESS_REQUEST
          ) {
            const products = activeProductsService.data.responseMessage.map(
              (product) => {
                return {
                  label: product.menuOptionName,
                  value: product.idMenuOption,
                  // selected: false,
                };
              }
            );

            setActiveProducts(products);
          }
        }
      } catch (error) {
        console.log("====================================");
        console.log(error);
        console.log("====================================");
      }
    }

    setOpen(true);
    fetchDataActiveProduct();
  };

  const handleClose = () => {
    setOpen(false);
    setActiveStep(0);
    reset();
  };

  const { t } = useTranslation();

  const { reset } = useForm({
    resolver: yupResolver(),
  });

  const [roleInfo, setRoleInfo] = useState({});
  const pullDataInfo = (data) => {
    setRoleInfo(data);
  };

  const menuInfo = [];

  const pullMenuInfo = (menuIds) => {
    const finalMenu = menuIds.map((idMenuOption) => {
      return idMenuOption;
    });

    return finalMenu;
  };

  useEffect(() => {
    setRoleInfo({
      idProduct: props.currentRole.idMenuOption,
      product: props.currentRole.menuOptionName,
      role: props.currentRole.nameRole,
      description: props.currentRole.descriptionRole,
      status: props.currentRole.state,
      menu: props.currentRole.lstMenuOptions,
    });
  }, []);

  const resultMenuInfo = [];
  for (let i in menuInfo) resultMenuInfo.push(menuInfo[i]);

  /**
   * Función para editar un rol
   * @param {*} menuOptions  opciones de menú seleccionadas
   */
  const handleEditRole = async (menuOptions) => {
    try {
      const obj = {
        pk: props.currentRole.pk,
        sk: props.currentRole.sk,
        idRole: props.currentRole.idRole,
        nameRole: roleInfo.role ? roleInfo.role : "",
        descriptionRole: roleInfo.description ? roleInfo.description : "",
        state: Number(roleInfo.status),
        idMenuOption: roleInfo.idProduct ? roleInfo.idProduct : "",
        menuOptionName: roleInfo.product ? roleInfo.product : "",
        clientType: roleInfo.clientType,
        userModification: userData.nameUser,
        lstMenuOptions: menuOptions,
      };

      const editRoleService = await EditRole(obj);

      props.setResponseData(editRoleService);
      props.openModal(true);
      if (editRoleService.status === CODES.COD_RESPONSE_HTTP_OK) {
        if (editRoleService.data.responseCode === CODES.COD_RESPONSE_SUCCESS) {
          props.setModified(!props.modified);
          props.setRefreshFilters(!props.refreshFilters);
          props.setResponseData({
            status: editRoleService.status,
            data: {
              responseCode: editRoleService.data.responseCode,
              responseMessage: "",
            },
          });
        } else {
          props.setResponseData(editRoleService);
        }
      } else {
        props.setResponseData(editRoleService);
      }
      props.setIsOpenModal(true);
    } catch (error) {
      console.log("====================================");
      console.log(error);
      console.log("====================================");
    }
    handleClose();
    setActiveStep(0);
  };

  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <EditRoleInformation
            onClose={handleClose}
            pullDataInfo={pullDataInfo}
            nextStep={nextStep}
            roleInfo={roleInfo}
            currentRole={props.currentRole}
            activeProducts={activeProducts}
          />
        );
      case 1:
        return (
          <EditRoleMenu
            pullMenuInfo={pullMenuInfo}
            previusStep={previusStep}
            handleEditRole={handleEditRole}
            roleInfo={roleInfo}
            currentRole={props.currentRole}
          />
        );
      default:
        return "unknown step";
    }
  }
  const methods = useForm({
    defaultValues: {
      role: "",
      description: "",
      status: "",
    },
  });

  const [activeStep, setActiveStep] = React.useState(0);

  const nextStep = (data) => {
    setActiveStep(data);
  };

  const previusStep = (data) => {
    setActiveStep(data);
  };

  return (
    <Grid>
      <EditOutlinedIcon
        sx={{ fontSize: 22, color: "#543ab4" }}
        onClick={handleClickOpen}
      />
      <Dialog
        onClose={handleClose}
        aria-labelledby="title"
        open={open}
        BackdropProps={{
          style: {
            backgroundColor: "rgba(85,115,185,0.2)",
          },
        }}
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              height: "100%",
              maxWidth: "80rem",
              maxHeight: "45rem",
              boxShadow: "none",
              borderRadius: "22px",
              padding: "2rem",
            },
          },
        }}
      >
        <DialogContent>
          <Box className="stepper-container">
            <Stepper className="modalEditRoles-stepper" activeStep={activeStep}>
              <Step>
                <StepLabel>{t("App.stepper.stepOne")}</StepLabel>
              </Step>

              <Step>
                <StepLabel>{t("App.stepper.stepTwo")}</StepLabel>
              </Step>
            </Stepper>
          </Box>

          <BootstrapDialogTitle
            id="title"
            className="display-large__primary-one"
            onClose={handleClose}
          >
            {activeStep === 0
              ? t("App.editRole.title")
              : t("App.editRole.title2")}
          </BootstrapDialogTitle>

          <FormProvider {...methods}>{getStepContent(activeStep)}</FormProvider>
        </DialogContent>
      </Dialog>
    </Grid>
  );
};

export default ModalEditRoles;
